export default __webpack_public_path__ + "static/media/MarkW07-Light.523039f6.woff2";